/**
 * Calls cb function when seal subscription widget is loaded
 *
 * @param {() => void} cb
 */
function onSealSubscriptionLoaded(cb) {
    document.addEventListener('sealsubs:subscription_widget_created', function () {
        cb();
    });
}

/**
 * When seal subscription widget is loaded, cb is called with sellingGroups as argument
 *
 * @param {(arg: Sellingplangroup[] | undefined) => void} cb
 */
function getSealSellingGroups(cb) {
    onSealSubscriptionLoaded(() => {
        // Select subscription object from widget
        const widgetEl = document.querySelectorAll('.sealsubs-target-element.sealsubs-full');
        const data = [];
        widgetEl.forEach((el) => {
            const subsStr = el.getAttribute('data-product');
            data.push(JSON.parse(subsStr));
        })

      /**
       *
       * @type {Sellingplangroup[]}
       */
        const sellingPlans = data.map((sub) => {
            return sub.selling_plan_groups;
        }).flat();
        cb(sellingPlans);
    })
}
